import { useMemo } from 'react';
import { useAppSelector } from '@/app/hooks';
import { selectUser } from '@/entities/user';
import { brand } from '@/brand';
import { buildMenu } from '@/app/navigation/buildMenu';
import { useNavTranslate } from '@/app/navigation/useNavTranslate';
import type { SidebarMenuItem } from '../ui/MenuItem';

// Пункты меню активного бренда с бейджами и рантайм-условиями из /me. Один
// источник на все виды навигации: сайдбар и шторка (MenuList), рейка планшета и
// меню на весь экран (compactNav = 'rail-topbar').
export const useMenuItems = (): SidebarMenuItem[] => {
  const user = useAppSelector(selectUser);
  const tNav = useNavTranslate();

  return useMemo(
    () =>
      buildMenu(
        brand,
        {
          referralSystem: Boolean(user?.referral_system),
          // Пилотный список из трёх почт снят 21.09.2026: фичу раскатали на всех,
          // пункт держится только на бренд-флаге.
          pwaHandoff: brand.features.pwaHandoff,
          badges: {
            news: user?.news ?? null,
            tickets: user?.new_tickets ?? null,
          },
        },
        tNav,
      ),
    [user?.referral_system, user?.news, user?.new_tickets, tNav],
  );
};
